










































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import { DepositEditUseCase } from '@/modules/deposit/use-cases/admin/deposit-edit.use-case'
import AdminDepositShowTabular from '@/modules/deposit/components/admin/AdminDepositShowTabular.vue'
import { DepositResourceType, DepositStatus } from '@/modules/deposit/models/deposit-resource.model'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import { DateHelper } from '@/modules/shared/helpers/date'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import AdminDepositCreateForm from '@/modules/deposit/components/admin/AdminDepositCreateForm.vue'
import AdminDepositPayOffDialog from '@/modules/deposit/components/admin/pay-dialog/AdminDepositPayOffDialog.vue'
import {
  BasicDepositBankAccountResourceModel
} from '@/modules/deposit-bank-account/models/deposit-bank-account-resource.model'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'واریزی'
  },
  metaInfo: {
    title: 'واریزی'
  },
  components: {
    AdminDepositCreateForm,
    MediaUploader,
    CopyableText,
    TesDatePicker,
    BaseSelect,
    CurrencyInput,
    AdminDepositShowTabular,
    SimpleHeader,
    AdminUserInfoButton,
    BaseCard,
    BaseInput,
    BaseButton,
    PriceView,
    Toggle
  }
})
export default class ShowPage extends Vue {
  constructor(
    private readonly depositEditUseCase: DepositEditUseCase,
    private readonly dateHelper: DateHelper
  ) {
    super()
  }


  @Prop() depositData!: DepositResourceType
  private deposit: DepositResourceType = this.initData()

  initData() {
    if (!this.depositData.data.bank_account)
      this.depositData.data.bank_account = <BasicDepositBankAccountResourceModel>{}
    return this.depositData
  }

  updated() {
    //on update : deposit's image sync with depositData's image -> prevent duplication
    return this.deposit.data.reception_image = this.depositData.data.reception_image
  }

  onSubmit() {
    this.depositEditUseCase.execute(this.depositData.data.id, this.deposit.data)
  }

  onDestroy() {
    //this.service.destroy(this.deposit.data.id)
  }

  get canPayOff() {
    return (this.depositData.data.status === DepositStatus.PENDING || this.depositData.data.status === DepositStatus.FREEZE)
  }

  dialogShow() {
    let withData = { ...this.depositData }
    delete withData.data
    this.$q.dialog({
      component: AdminDepositPayOffDialog,
      deposit: this.depositData.data,
      withData: withData
    })
  }
}
